import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './index.css'
import './styles/tokens.css';
import './styles/design-system.css';
import './styles/search-workspace.css';
import { ThemeProvider } from './design-system/ThemeProvider';
// Font imports (Self-hosted)
import '@fontsource/inter/300.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/source-serif-4/400.css';
import '@fontsource/source-serif-4/600.css';
import '@fontsource/source-serif-4/700.css';
import { SiteVariantProvider } from './context/SiteVariantContext';
import App from './App.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider>
    <HelmetProvider>
      <SiteVariantProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </SiteVariantProvider>
    </HelmetProvider>
    </ThemeProvider>
  </StrictMode>,
)
